import { AuthState } from './types';

// Constants for Zustand store keys and actions
export const AUTH_STORE_KEYS = 'auth-store';

export const defaultInitState: AuthState = {
   user: null,
   isAuthenticated: false,
   accessToken: null,
} as const;
